import { API_KEY } from "./Config";
import axios from "./Axios";
import { getItem } from "../cookie/Cookie";
import {
  startLoading,
  stopLoading,
} from "../../components/ruralDetailsCount/store";

interface ApiRequest {
  apiUrl: string;
  login?: number;
  body?: Record<string, any>;
}

export const getApiMethod = async (dispatch: any, data: ApiRequest) => {
  dispatch(startLoading(data?.apiUrl));

  const api = data.apiUrl;
  const headers =
    data.login === 0
      ? { "X-Client-Secret": API_KEY }
      : { Authorization: await getItem("token") };

  try {
    const response = await axios.get(api, { headers });
    return response;
  } catch (error) {
    console.error("GET request failed:", error);
    throw error;
  } finally {
    dispatch(stopLoading(data?.apiUrl));
  }
};

export const postApiMethod = async (dispatch: any, data: ApiRequest) => {
  dispatch(startLoading(data.apiUrl));
  const api = data.apiUrl;
  const headers =
    data.login === 0
      ? { "X-Client-Secret": API_KEY }
      : { Authorization: await getItem("token") };
  try {
    const response = await axios.post(api, data.body, { headers });
    return response;
  } catch (error) {
    console.error("POST request failed:", error);
    throw error;
  } finally {
    dispatch(stopLoading(data.apiUrl));
  }
};

export const putApiMethod = async (data: ApiRequest) => {
  const api = data.apiUrl;
  const headers =
    data.login === 0
      ? { "X-Client-Secret": API_KEY }
      : { Authorization: await getItem("token") };

  try {
    const response = await axios.put(api, data.body, { headers });
    return response;
  } catch (error) {
    console.error("PUT request failed:", error);
    throw error;
  }
};

export const deleteApiMethod = async (data: ApiRequest) => {
  const api = data.apiUrl;
  const headers =
    data.login === 0
      ? { "X-Client-Secret": API_KEY }
      : { Authorization: await getItem("token") };

  try {
    const response = await axios.delete(api, { headers });
    return response;
  } catch (error) {
    console.error("DELETE request failed:", error);
    throw error;
  }
};
